// import React, { useEffect, useMemo, useState } from "react";
// import api from "../../../api";
// import {
//   Modal,
//   Button,
//   Form,
//   InputGroup,
//   Pagination,
//   Spinner,
//   Badge,
// } from "react-bootstrap";
// import "./AllocationPage.css";

// export default function AllocationPage() {
//   const [units, setUnits] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [products, setProducts] = useState([]);

//   const [unitId, setUnitId] = useState("");
//   const [userId, setUserId] = useState("");
//   const [productId, setProductId] = useState("");
//   const [qty, setQty] = useState(1);
//   const [notes, setNotes] = useState("");

//   const [allocations, setAllocations] = useState([]);
//   const [editing, setEditing] = useState(null);
//   const [showCreate, setShowCreate] = useState(false);

//   const [search, setSearch] = useState("");
//   const [statusFilter, setStatusFilter] = useState("ALL");

//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);

//   useEffect(() => {
//     fetchAll();
//   }, []);

//   useEffect(() => {
//     if (unitId) fetchUsers(unitId);
//     else setUsers([]);

//     setUserId("");
//   }, [unitId]);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [search, statusFilter, rowsPerPage]);

//   const fetchAll = async () => {
//     try {
//       setLoading(true);

//       const [unitRes, productRes, allocationRes] = await Promise.all([
//         api.get(`/alloc/units`),
//         api.get(`/alloc/products`),
//         api.get(`/alloc`),
//       ]);

//       setUnits(Array.isArray(unitRes.data) ? unitRes.data : []);
//       setProducts(Array.isArray(productRes.data) ? productRes.data : []);
//       setAllocations(Array.isArray(allocationRes.data) ? allocationRes.data : []);
//     } catch (error) {
//       console.error("Fetch Allocation Data Error:", error);
//       alert("Failed to fetch allocation data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchUsers = async (uId) => {
//     try {
//       const { data } = await api.get(
//         `/alloc/users/by-unit/${uId}`
//       );
//       setUsers(Array.isArray(data) ? data : []);
//     } catch (error) {
//       console.error("Fetch Users Error:", error);
//       setUsers([]);
//     }
//   };

//   const fetchProducts = async () => {
//     const { data } = await api.get(`/alloc/products`);
//     setProducts(Array.isArray(data) ? data : []);
//   };

//   const fetchAllocations = async () => {
//     const { data } = await api.get(`/alloc`);
//     setAllocations(Array.isArray(data) ? data : []);
//   };

//   const selectedProduct = useMemo(() => {
//     return products.find((p) => String(p.id) === String(productId));
//   }, [products, productId]);

//   const specLine = (product) => {
//     if (!product) return "-";

//     const ram = product.ram_gb ? `${product.ram_gb}GB` : "-";
//     const storage = product.ssd_gb
//       ? `${product.ssd_gb}GB SSD`
//       : product.hdd_gb
//       ? `${product.hdd_gb}GB HDD`
//       : "-";

//     return `${product.processor || "-"} / ${ram} / ${storage}`;
//   };

//   const allocWithProduct = useMemo(() => {
//     return allocations.map((row) => ({
//       ...row,
//       __prod:
//         products.find((p) => String(p.id) === String(row.product_id)) || null,
//     }));
//   }, [allocations, products]);

//   const filtered = useMemo(() => {
//     const q = search.trim().toLowerCase();

//     return allocWithProduct.filter((row) => {
//       const passStatus =
//         statusFilter === "ALL" ? true : row.status === statusFilter;

//       if (!q) return passStatus;

//       const haystack = [
//         row.sku,
//         row.product_name,
//         row.unit_name,
//         row.user_name,
//         row.status,
//         row.notes,
//         row.allocated_at,
//         row.return_at,
//         row.__prod?.model_no,
//         row.__prod?.serial_no,
//         row.__prod?.processor,
//       ]
//         .filter(Boolean)
//         .join(" ")
//         .toLowerCase();

//       return passStatus && haystack.includes(q);
//     });
//   }, [allocWithProduct, search, statusFilter]);

//   const stats = useMemo(() => {
//     return {
//       totalProducts: products.length,
//       totalAllocations: allocations.length,
//       allocated: allocations.filter((a) => a.status === "ALLOCATED").length,
//       returned: allocations.filter((a) => a.status === "RETURNED").length,
//       cancelled: allocations.filter((a) => a.status === "CANCELLED").length,
//     };
//   }, [products, allocations]);

//   const totalPages = Math.ceil(filtered.length / rowsPerPage);
//   const indexOfLast = currentPage * rowsPerPage;
//   const indexOfFirst = indexOfLast - rowsPerPage;
//   const pageData = filtered.slice(indexOfFirst, indexOfLast);

//   const resetCreateForm = () => {
//     setUnitId("");
//     setUserId("");
//     setProductId("");
//     setQty(1);
//     setNotes("");
//   };

//   const openCreateModal = () => {
//     resetCreateForm();
//     setShowCreate(true);
//   };

//   const submit = async () => {
//     if (!unitId || !userId || !productId || !qty) {
//       alert("Please fill all required fields");
//       return;
//     }

//     if (selectedProduct && Number(qty) > Number(selectedProduct.available_qty)) {
//       alert(`Only ${selectedProduct.available_qty} available for ${selectedProduct.sku}`);
//       return;
//     }

//     try {
//       setSaving(true);

//       await api.post(`/alloc`, {
//         unit_id: Number(unitId),
//         user_id: Number(userId),
//         product_id: Number(productId),
//         qty: Number(qty),
//         notes,
//       });

//       resetCreateForm();
//       setShowCreate(false);

//       await fetchProducts();
//       await fetchAllocations();

//       alert("Product allocated successfully");
//     } catch (error) {
//       console.error("Allocation Error:", error);
//       alert(error?.response?.data?.error || "Failed to allocate product");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const remove = async (id) => {
//     if (!window.confirm("Delete this allocation?")) return;

//     try {
//       await api.delete(`/alloc/${id}`);
//       await fetchProducts();
//       await fetchAllocations();
//       alert("Allocation deleted successfully");
//     } catch (error) {
//       console.error("Delete Allocation Error:", error);
//       alert("Failed to delete allocation");
//     }
//   };

//   const setStatus = async (row, status) => {
//     try {
//       await api.put(`/alloc/${row.id}/status`, {
//         status,
//       });

//       await fetchProducts();
//       await fetchAllocations();

//       alert(`Status changed to ${status}`);
//     } catch (error) {
//       console.error("Status Update Error:", error);
//       alert("Failed to update status");
//     }
//   };

//   const saveEdit = async () => {
//     if (!editing) return;

//     try {
//       setSaving(true);

//       await api.put(`/alloc/${editing.id}`, {
//         product_id: Number(editing.product_id),
//         unit_id: Number(editing.unit_id),
//         user_id: Number(editing.user_id),
//         qty: Number(editing.qty),
//         notes: editing.notes || "",
//       });

//       setEditing(null);

//       await fetchProducts();
//       await fetchAllocations();

//       alert("Allocation updated successfully");
//     } catch (error) {
//       console.error("Edit Allocation Error:", error);
//       alert("Failed to update allocation");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const clearFilters = () => {
//     setSearch("");
//     setStatusFilter("ALL");
//     setCurrentPage(1);
//   };

//   const getStatusBadge = (status) => {
//     if (status === "RETURNED") {
//       return (
//         <Badge className="unit-status alloc-status-returned">Returned</Badge>
//       );
//     }

//     if (status === "CANCELLED") {
//       return (
//         <Badge className="unit-status alloc-status-cancelled">Cancelled</Badge>
//       );
//     }

//     return (
//       <Badge className="unit-status alloc-status-allocated">Allocated</Badge>
//     );
//   };

//   const exportCSV = () => {
//     if (!filtered.length) {
//       alert("No data available to export");
//       return;
//     }

//     const headers = [
//       "ID",
//       "SKU",
//       "Product",
//       "Unit",
//       "User",
//       "Qty",
//       "Status",
//       "Notes",
//       "Issue Date",
//       "Return Date",
//       "Model",
//       "Serial",
//       "Specification",
//     ];

//     const rows = filtered.map((row) => [
//       row.id,
//       row.sku,
//       row.product_name,
//       row.unit_name,
//       row.user_name,
//       row.qty,
//       row.status,
//       row.notes,
//       row.allocated_at,
//       row.return_at,
//       row.__prod?.model_no || "",
//       row.__prod?.serial_no || "",
//       specLine(row.__prod),
//     ]);

//     const csvContent = [headers, ...rows]
//       .map((row) =>
//         row
//           .map((value) => `"${String(value || "").replace(/"/g, '""')}"`)
//           .join(",")
//       )
//       .join("\n");

//     const blob = new Blob([csvContent], {
//       type: "text/csv;charset=utf-8;",
//     });

//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");

//     link.href = url;
//     link.download = "product-allocations.csv";
//     link.click();

//     URL.revokeObjectURL(url);
//   };

//   const org = {
//     name: "Jaipuria Schools",
//     address: "Sector-XX, City, State - 000000",
//     phone: "+91-00000-00000",
//     email: "info@jaipuria.edu",
//   };

//   const esc = (value) =>
//     String(value ?? "")
//       .replace(/&/g, "&amp;")
//       .replace(/</g, "&lt;")
//       .replace(/>/g, "&gt;");

//   const pad2 = (number) => String(number).padStart(2, "0");

//   const formatDate = (date) => {
//     const dt = date instanceof Date ? date : new Date(date);
//     return `${pad2(dt.getDate())}-${pad2(dt.getMonth() + 1)}-${dt.getFullYear()}`;
//   };

//   const buildSignSheetHTML = (rows, title = "Product Allocation Sign Sheet") => {
//     const today = formatDate(new Date());

//     const itemRows = rows
//       .map((row, index) => {
//         const product =
//           products.find((p) => String(p.id) === String(row.product_id)) || {};

//         return `
//           <tr>
//             <td>${index + 1}</td>
//             <td>
//               <div><b>${esc(row.sku || "-")}</b> — ${esc(row.product_name || "-")}</div>
//               <div style="color:#6b7280;font-size:11px">
//                 M: ${esc(product.model_no || "-")} • S: ${esc(product.serial_no || "-")} • ${esc(specLine(product))}
//               </div>
//             </td>
//             <td>${esc(row.unit_name || "-")}</td>
//             <td>${esc(row.user_name || "-")}</td>
//             <td style="text-align:right;font-weight:700">${Number(row?.qty ?? 0)}</td>
//             <td>${esc(row.status || "-")}</td>
//             <td>${esc(row.notes || "-")}</td>
//           </tr>`;
//       })
//       .join("");

//     const singleMeta =
//       rows.length === 1
//         ? (() => {
//             const row = rows[0];
//             const product =
//               products.find((p) => String(p.id) === String(row.product_id)) || {};

//             return `
//               <table class="meta">
//                 <tr>
//                   <td><b>Unit:</b> ${esc(row.unit_name || "-")}</td>
//                   <td><b>User:</b> ${esc(row.user_name || "-")}</td>
//                   <td><b>Model/Serial:</b> ${esc(product.model_no || "-")} / ${esc(product.serial_no || "-")}</td>
//                 </tr>
//               </table>`;
//           })()
//         : "";

//     return `<!DOCTYPE html>
// <html>
// <head>
// <meta charset="utf-8"/>
// <title>${esc(title)}</title>
// <style>
//   @page { size: A4; margin: 16mm 14mm; }
//   html, body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
//   body { font-family: Arial, sans-serif; color: #111827; }
//   .head { display:flex; justify-content:space-between; align-items:flex-start; border-bottom:2px solid #e5e7eb; padding-bottom:10px; margin-bottom:10px; }
//   .brand { font-weight:800; font-size:20px; line-height:1.1; }
//   .muted { color:#6b7280; font-size:12px; }
//   .title { text-align:center; margin:8px 0 12px; font-size:18px; font-weight:800; }
//   .meta { width:100%; border:1px solid #e5e7eb; border-radius:8px; padding:8px; font-size:12px; margin-bottom:10px; }
//   .meta td { padding:4px 6px; vertical-align:top; }
//   .table { width:100%; border-collapse:collapse; margin-top:8px; font-size:12px; }
//   .table th, .table td { border:1px solid #e5e7eb; padding:6px 8px; }
//   .table thead th { background:#f9fafb; text-transform:uppercase; letter-spacing:.02em; font-size:11px; color:#6b7280; }
//   .sign-grid { display:grid; grid-template-columns:1fr 1fr 1fr; gap:14px; margin-top:18px; }
//   .sign-card { border:1px dashed #cbd5e1; border-radius:8px; padding:10px; }
//   .sign-line { border-top:1px solid #94a3b8; margin-top:28px; }
//   .label { font-size:11px; color:#6b7280; }
//   .foot { margin-top:14px; font-size:11px; color:#6b7280; }
//   .stamp { border:1px dashed #94a3b8; height:70px; display:flex; align-items:center; justify-content:center; color:#64748b; border-radius:6px; margin-top:6px;}
// </style>
// </head>
// <body>
//   <div class="head">
//     <div>
//       <div class="brand">${esc(org.name)}</div>
//       <div class="muted">${esc(org.address)}</div>
//       <div class="muted">${esc(org.phone)} | ${esc(org.email)}</div>
//     </div>
//     <div class="muted" style="text-align:right">
//       <div>Date: <b>${esc(today)}</b></div>
//       <div>Doc #: ____________</div>
//     </div>
//   </div>

//   <div class="title">${esc(title)}</div>

//   <table class="meta">
//     <tr>
//       <td><b>Total Items:</b> ${rows.length}</td>
//       <td><b>Prepared By:</b> ____________________</td>
//       <td><b>Checked By:</b> ____________________</td>
//     </tr>
//   </table>

//   ${singleMeta}

//   <table class="table">
//     <thead>
//       <tr>
//         <th>#</th>
//         <th>Product & Spec</th>
//         <th>Unit</th>
//         <th>User</th>
//         <th>Qty</th>
//         <th>Status</th>
//         <th>Notes</th>
//       </tr>
//     </thead>
//     <tbody>${itemRows}</tbody>
//   </table>

//   <div class="sign-grid">
//     <div class="sign-card">
//       <div><b>Issued By</b></div>
//       <div class="label">Name & Signature</div>
//       <div class="sign-line"></div>
//       <div class="label">Date</div>
//       <div>____ / ____ / ______</div>
//       <div class="stamp">Office Stamp</div>
//     </div>
//     <div class="sign-card">
//       <div><b>Received By</b></div>
//       <div class="label">Name & Signature</div>
//       <div class="sign-line"></div>
//       <div class="label">Date</div>
//       <div>____ / ____ / ______</div>
//     </div>
//     <div class="sign-card">
//       <div><b>Verified By</b></div>
//       <div class="label">Name & Signature</div>
//       <div class="sign-line"></div>
//       <div class="label">Date</div>
//       <div>____ / ____ / ______</div>
//     </div>
//   </div>

//   <div class="foot">
//     <b>Note:</b> Items received in good condition unless otherwise stated. Discrepancies must be reported within 24 hours.
//   </div>

//   <script>
//     window.onload = function(){ try{ window.focus(); }catch(e){} window.print(); };
//   </script>
// </body>
// </html>`;
//   };

//   const printRows = (rows, title) => {
//     const html = buildSignSheetHTML(rows || [], title);
//     const printWindow = window.open("", "_blank", "width=900,height=1000");

//     if (!printWindow) {
//       alert("Popup blocked. Please allow popups to print.");
//       return;
//     }

//     printWindow.document.open();
//     printWindow.document.write(html);
//     printWindow.document.close();

//     printWindow.onload = () => {
//       try {
//         printWindow.focus();
//       } catch {}
//       printWindow.print();
//     };
//   };

//   const printSingle = (row) => {
//     if (row) printRows([row], "Product Allocation Sign Sheet - Single");
//   };

//   const printAll = () => {
//     printRows(filtered || [], "Product Allocation Sign Sheet - Filtered");
//   };

//   return (
//     <div className="unit-page inventory-allocation-theme">
//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Inventory</div>
//           <h2>Product Allocation</h2>
//           <p>Allocate products to users, manage returns, cancellations and print sign sheets.</p>
//         </div>

//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchAll}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>

//           <Button className="unit-btn unit-btn-light" onClick={exportCSV}>
//             <i className="fa-solid fa-file-csv" aria-hidden="true"></i>
//             Export CSV
//           </Button>

//           <Button className="unit-btn unit-btn-light" onClick={printAll}>
//             <i className="fa-solid fa-print" aria-hidden="true"></i>
//             Print {search || statusFilter !== "ALL" ? "Filtered" : "All"}
//           </Button>

//           <Button className="unit-btn unit-btn-primary" onClick={openCreateModal}>
//             <i className="fa-solid fa-plus" aria-hidden="true"></i>
//             Allocate
//           </Button>
//         </div>
//       </div>

//       <div className="unit-stats-row">
//         <div className="unit-stat-card">
//           <span>Total Products</span>
//           <strong>{stats.totalProducts}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>Total Records</span>
//           <strong>{stats.totalAllocations}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>Allocated</span>
//           <strong>{stats.allocated}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>Returned</span>
//           <strong>{stats.returned}</strong>
//         </div>

//         <div className="unit-stat-card">
//           <span>Cancelled</span>
//           <strong>{stats.cancelled}</strong>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>Allocation List</h5>
//             <p>Search, filter, update status, edit quantity and print allocation records.</p>
//           </div>

//           <div className="unit-toolbar-actions">
//             <InputGroup className="unit-search">
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>

//               <Form.Control
//                 placeholder="Search product, model, serial, unit, user..."
//                 aria-label="Search product, model, serial, unit, user"
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//               />

//               {search && (
//                 <Button className="unit-clear-btn" onClick={() => setSearch("")}>
//                   Clear
//                 </Button>
//               )}
//             </InputGroup>

//             <Form.Select
//               className="unit-page-size"
//               value={statusFilter}
//               onChange={(e) => setStatusFilter(e.target.value)}
//             >
//               <option value="ALL">All Status</option>
//               <option value="ALLOCATED">Allocated</option>
//               <option value="RETURNED">Returned</option>
//               <option value="CANCELLED">Cancelled</option>
//             </Form.Select>

//             <Form.Select
//               className="unit-page-size"
//               value={rowsPerPage}
//               onChange={(e) => setRowsPerPage(Number(e.target.value))}
//             >
//               <option value={5}>5 rows</option>
//               <option value={10}>10 rows</option>
//               <option value={20}>20 rows</option>
//               <option value={50}>50 rows</option>
//             </Form.Select>

//             {(search || statusFilter !== "ALL") && (
//               <Button className="unit-btn unit-btn-light" onClick={clearFilters}>
//                 Reset
//               </Button>
//             )}
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader">
//               <Spinner animation="border" />
//               <p>Loading allocations...</p>
//             </div>
//           ) : (
//             <table className="table unit-table">
//               <thead>
//                 <tr>
//                   <th style={{ width: "80px" }}>ID</th>
//                   <th>Product</th>
//                   <th>Unit</th>
//                   <th>User</th>
//                   <th>Qty</th>
//                   <th>Status</th>
//                   <th>Notes</th>
//                   <th>Issue Date</th>
//                   <th>Return Date</th>
//                   <th className="text-end" style={{ width: "250px" }}>
//                     Actions
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {pageData.length > 0 ? (
//                   pageData.map((row) => {
//                     const product = row.__prod;

//                     return (
//                       <tr key={row.id}>
//                         <td>
//                           <span className="unit-id">#{row.id}</span>
//                         </td>

//                         <td>
//                           <div className="unit-name-box">
//                             <div className="unit-letter">
//                               {row.product_name?.charAt(0)?.toUpperCase() || "P"}
//                             </div>

//                             <div>
//                               <strong>
//                                 {row.sku} — {row.product_name}
//                               </strong>
//                               <small>
//                                 M: {product?.model_no || "-"} • S:{" "}
//                                 {product?.serial_no || "-"} • {specLine(product)}
//                               </small>
//                             </div>
//                           </div>
//                         </td>

//                         <td>
//                           <Badge className="unit-status">
//                             {row.unit_name || "-"}
//                           </Badge>
//                         </td>

//                         <td>
//                           <Badge className="unit-status">
//                             {row.user_name || "-"}
//                           </Badge>
//                         </td>

//                         <td>
//                           <span className="unit-id">{row.qty}</span>
//                         </td>

//                         <td>{getStatusBadge(row.status)}</td>

//                         <td
//                           style={{
//                             maxWidth: "180px",
//                             whiteSpace: "nowrap",
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                           }}
//                           title={row.notes || ""}
//                         >
//                           {row.notes || "-"}
//                         </td>

//                         <td>{row.allocated_at || "-"}</td>
//                         <td>{row.return_at || "-"}</td>

//                         <td>
//                           <div className="unit-actions">
//                             <Button
//                               className="unit-icon-btn unit-edit"
//                               title="Edit"
//                               aria-label={`Edit allocation for ${row.product_name || "product"}`}
//                               onClick={() => setEditing({ ...row })}
//                             >
//                               <i className="fa-solid fa-pen" aria-hidden="true"></i>
//                             </Button>

//                             <Button
//                               className="unit-icon-btn unit-delete"
//                               title="Delete"
//                               aria-label={`Delete allocation for ${row.product_name || "product"}`}
//                               onClick={() => remove(row.id)}
//                             >
//                               <i className="fa-solid fa-trash" aria-hidden="true"></i>
//                             </Button>

//                             <Button
//                               className="unit-icon-btn unit-edit"
//                               title="Mark Returned"
//                               aria-label={`Mark ${row.product_name || "allocation"} as returned`}
//                               onClick={() => setStatus(row, "RETURNED")}
//                             >
//                               <i className="fa-solid fa-rotate-left" aria-hidden="true"></i>
//                             </Button>

//                             <Button
//                               className="unit-icon-btn unit-delete"
//                               title="Cancel Allocation"
//                               aria-label={`Cancel allocation for ${row.product_name || "product"}`}
//                               onClick={() => setStatus(row, "CANCELLED")}
//                             >
//                               <i className="fa-solid fa-ban" aria-hidden="true"></i>
//                             </Button>

//                             <Button
//                               className="unit-icon-btn unit-edit"
//                               title="Print Sign Sheet"
//                               aria-label={`Print sign sheet for ${row.product_name || "product"}`}
//                               onClick={() => printSingle(row)}
//                             >
//                               <i className="fa-solid fa-print" aria-hidden="true"></i>
//                             </Button>
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td colSpan="10">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-box-open" aria-hidden="true"></i>
//                         </div>
//                         <h5>No allocations found</h5>
//                         <p>Try another filter or allocate a new product.</p>

//                         <Button
//                           className="unit-btn unit-btn-primary"
//                           onClick={openCreateModal}
//                         >
//                           <i className="fa-solid fa-plus" aria-hidden="true"></i>
//                           Allocate Product
//                         </Button>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">
//             Showing{" "}
//             <strong>{filtered.length === 0 ? 0 : indexOfFirst + 1}</strong> to{" "}
//             <strong>{Math.min(indexOfLast, filtered.length)}</strong> of{" "}
//             <strong>{filtered.length}</strong> entries
//           </div>

//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev
//                 disabled={currentPage === 1}
//                 onClick={() => setCurrentPage((prev) => prev - 1)}
//               />

//               {[...Array(totalPages)].map((_, index) => (
//                 <Pagination.Item
//                   key={index + 1}
//                   active={index + 1 === currentPage}
//                   onClick={() => setCurrentPage(index + 1)}
//                 >
//                   {index + 1}
//                 </Pagination.Item>
//               ))}

//               <Pagination.Next
//                 disabled={currentPage === totalPages}
//                 onClick={() => setCurrentPage((prev) => prev + 1)}
//               />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Modal
//         show={showCreate}
//         onHide={() => setShowCreate(false)}
//         centered
//         className="unit-modal"
//         dialogClassName="admin-teal-modal"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Allocate Product</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <div className="row g-3">
//             <div className="col-md-6">
//               <Form.Group>
//                 <Form.Label>Unit</Form.Label>
//                 <Form.Select
//                   value={unitId}
//                   onChange={(e) => setUnitId(e.target.value)}
//                 >
//                   <option value="">Select Unit</option>
//                   {units.map((unit) => (
//                     <option key={unit.id} value={unit.id}>
//                       {unit.name}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </div>

//             <div className="col-md-6">
//               <Form.Group>
//                 <Form.Label>User</Form.Label>
//                 <Form.Select
//                   value={userId}
//                   onChange={(e) => setUserId(e.target.value)}
//                   disabled={!unitId}
//                 >
//                   <option value="">Select User</option>
//                   {users.map((u) => (
//                     <option key={u.id} value={u.id}>
//                       {u.name}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>
//             </div>

//             <div className="col-md-8">
//               <Form.Group>
//                 <Form.Label>Product</Form.Label>
//                 <Form.Select
//                   value={productId}
//                   onChange={(e) => setProductId(e.target.value)}
//                 >
//                   <option value="">Select Product</option>
//                   {products.map((product) => (
//                     <option key={product.id} value={product.id}>
//                       {product.sku} — {product.name} (Avail:{" "}
//                       {product.available_qty})
//                     </option>
//                   ))}
//                 </Form.Select>

//                 {selectedProduct && (
//                   <small className="text-muted d-block mt-2">
//                     Total: {selectedProduct.total_qty} • Available:{" "}
//                     {selectedProduct.available_qty} <br />
//                     M: {selectedProduct.model_no || "-"} • S:{" "}
//                     {selectedProduct.serial_no || "-"} • {specLine(selectedProduct)}
//                   </small>
//                 )}
//               </Form.Group>
//             </div>

//             <div className="col-md-4">
//               <Form.Group>
//                 <Form.Label>Qty</Form.Label>
//                 <Form.Control
//                   type="number"
//                   min="1"
//                   value={qty}
//                   onChange={(e) => setQty(e.target.value)}
//                 />
//               </Form.Group>
//             </div>

//             <div className="col-12">
//               <Form.Group>
//                 <Form.Label>Notes</Form.Label>
//                 <Form.Control
//                   placeholder="Any remarks..."
//                   value={notes}
//                   onChange={(e) => setNotes(e.target.value)}
//                 />
//               </Form.Group>
//             </div>
//           </div>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button
//             className="unit-btn unit-btn-light"
//             onClick={() => setShowCreate(false)}
//           >
//             Cancel
//           </Button>

//           <Button
//             className="unit-btn unit-btn-primary"
//             onClick={submit}
//             disabled={saving}
//           >
//             {saving ? "Allocating..." : "Allocate"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <Modal
//         show={!!editing}
//         onHide={() => setEditing(null)}
//         centered
//         className="unit-modal"
//         dialogClassName="admin-teal-modal"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Allocation</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <Form.Group className="mb-3">
//             <Form.Label>Qty</Form.Label>
//             <Form.Control
//               type="number"
//               min="1"
//               value={editing?.qty || ""}
//               onChange={(e) =>
//                 setEditing({
//                   ...editing,
//                   qty: e.target.value,
//                 })
//               }
//             />
//           </Form.Group>

//           <Form.Group>
//             <Form.Label>Notes</Form.Label>
//             <Form.Control
//               value={editing?.notes || ""}
//               onChange={(e) =>
//                 setEditing({
//                   ...editing,
//                   notes: e.target.value,
//                 })
//               }
//             />
//           </Form.Group>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={() => setEditing(null)}>
//             Cancel
//           </Button>

//           <Button
//             className="unit-btn unit-btn-primary"
//             onClick={saveEdit}
//             disabled={saving}
//           >
//             {saving ? "Saving..." : "Save"}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }





import React, { useEffect, useMemo, useState } from "react";
import { compactPageItems } from "../../../components/ui/compactPagination";
import api from "../../../api";
import {
  Modal,
  Button,
  Form,
  InputGroup,
  Pagination,
  Spinner,
  Badge,
} from "react-bootstrap";
import "./AllocationPage.css";
import { usePermissions } from "../../../context/PermissionContext";

export default function AllocationPage() {
  const { can } = usePermissions();
  const canCreate = can("allocations", "create");
  const canEdit = can("allocations", "edit");
  const canDelete = can("allocations", "delete");
  const canChangeStatus = can("allocations", "change_status");
  const canExport = can("allocations", "export");

  const [units, setUnits] = useState([]);
  const [users, setUsers] = useState([]);
  const [products, setProducts] = useState([]);

  // Historical-allocation-UI gap fix: the Create modal's Product picker is
  // date-aware and deliberately kept SEPARATE from `products` above --
  // `products` still feeds the report filter dropdown, print sign sheets,
  // and stats, all of which must keep showing every eligible-today product
  // (and, for historical lookups like print/report, products regardless of
  // discard) without being narrowed by whatever date happens to be in the
  // Create modal. `pickerProducts` is refetched from GET /alloc/products
  // with `?allocation_date=` whenever that date changes.
  const [pickerProducts, setPickerProducts] = useState([]);
  const [pickerLoading, setPickerLoading] = useState(false);

  const [unitId, setUnitId] = useState("");
  const [userId, setUserId] = useState("");
  const [productId, setProductId] = useState("");
  const [qty, setQty] = useState(1);
  const [notes, setNotes] = useState("");
  const [allocatedAt, setAllocatedAt] = useState(() => {
    const d = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  });

  const [allocations, setAllocations] = useState([]);
  const [editing, setEditing] = useState(null);
  const [showCreate, setShowCreate] = useState(false);
  const [lifeWarning, setLifeWarning] = useState(null);

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");

  // Additional server-side report filters (GET /alloc/report). These are
  // kept separate from unitId/productId above, which belong to the
  // "Allocate a product" create form's cascading dropdowns.
  const [filterMonth, setFilterMonth] = useState("");
  const [filterYear, setFilterYear] = useState("");
  const [filterDateFrom, setFilterDateFrom] = useState("");
  const [filterDateTo, setFilterDateTo] = useState("");
  const [filterProductId, setFilterProductId] = useState("");
  const [filterUnitId, setFilterUnitId] = useState("");
  const [filterDepartmentId, setFilterDepartmentId] = useState("");
  const [filterAllocatedBy, setFilterAllocatedBy] = useState("");

  // Reference data for the new filter dropdowns.
  const [technicians, setTechnicians] = useState([]);
  const [departments, setDepartments] = useState([]);

  // Server-side paginated/filtered allocation list (GET /alloc/report).
  // NOTE: there is no generic "all users" endpoint wired into this page, so
  // the "Allotted user" filter is intentionally folded into the free-text
  // `search` box below (the backend's /alloc/report `search` param already
  // matches against the allotted user's name) instead of adding a separate
  // user-picker dropdown.
  const [reportItems, setReportItems] = useState([]);
  const [reportTotal, setReportTotal] = useState(0);
  const [reportLoading, setReportLoading] = useState(false);
  const [reportError, setReportError] = useState("");
  const [exporting, setExporting] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchAll();
    fetchFilterMeta();
  }, []);

  useEffect(() => {
    if (unitId) fetchUsers(unitId);
    else setUsers([]);

    setUserId("");
  }, [unitId]);

  // Historical-allocation-UI gap fix: re-evaluate the Create modal's
  // product picker every time the chosen Allocation Date changes (or the
  // modal opens) -- backend is the sole authority on eligibility for that
  // date (see fetchPickerProducts's own comment).
  useEffect(() => {
    if (!showCreate) return;
    fetchPickerProducts(allocatedAt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allocatedAt, showCreate]);

  useEffect(() => {
    setCurrentPage(1);
  }, [
    search,
    statusFilter,
    rowsPerPage,
    filterMonth,
    filterYear,
    filterDateFrom,
    filterDateTo,
    filterProductId,
    filterUnitId,
    filterDepartmentId,
    filterAllocatedBy,
  ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchReport();
    }, 300);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentPage,
    rowsPerPage,
    search,
    statusFilter,
    filterMonth,
    filterYear,
    filterDateFrom,
    filterDateTo,
    filterProductId,
    filterUnitId,
    filterDepartmentId,
    filterAllocatedBy,
  ]);

  const fetchAll = async () => {
    try {
      setLoading(true);

      const [unitRes, productRes, allocationRes] = await Promise.all([
        api.get(`/alloc/units`),
        api.get(`/alloc/products`),
        api.get(`/alloc`),
      ]);

      setUnits(Array.isArray(unitRes.data) ? unitRes.data : []);
      setProducts(Array.isArray(productRes.data) ? productRes.data : []);
      setAllocations(Array.isArray(allocationRes.data) ? allocationRes.data : []);
    } catch (error) {
      console.error("Fetch Allocation Data Error:", error);
      alert("Failed to fetch allocation data");
    } finally {
      setLoading(false);
    }
  };

  const fetchUsers = async (uId) => {
    try {
      const { data } = await api.get(
        `/alloc/users/by-unit/${uId}`
      );
      setUsers(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Fetch Users Error:", error);
      setUsers([]);
    }
  };

  const fetchProducts = async () => {
    const { data } = await api.get(`/alloc/products`);
    setProducts(Array.isArray(data) ? data : []);
  };

  // Date-aware picker for the Create modal only (see the `pickerProducts`
  // state comment above). Backend (`GET /alloc/products?allocation_date=`)
  // is the sole source of truth for eligibility -- this never filters
  // client-side beyond what the server already returned. If the currently
  // selected product falls out of the eligible list for the newly-requested
  // date, the selection is cleared with a specific reason when that reason
  // is known (the product was discarded on/before the requested date).
  const fetchPickerProducts = async (dateStr) => {
    try {
      setPickerLoading(true);
      const { data } = await api.get(`/alloc/products`, { params: { allocation_date: dateStr } });
      const nextProducts = Array.isArray(data) ? data : [];

      if (productId) {
        const stillEligible = nextProducts.some((p) => String(p.id) === String(productId));
        if (!stillEligible) {
          const previous = pickerProducts.find((p) => String(p.id) === String(productId));
          setProductId("");
          if (previous?.is_discarded && previous?.discarded_at) {
            alert(
              `This product was discarded on ${formatDate(previous.discarded_at)} and cannot be allocated on the selected date.`
            );
          } else if (previous) {
            alert("This product is no longer eligible for allocation on the selected date. Selection cleared.");
          }
        }
      }

      setPickerProducts(nextProducts);
    } catch (error) {
      console.error("Fetch picker products error:", error);
    } finally {
      setPickerLoading(false);
    }
  };

  const fetchAllocations = async () => {
    const { data } = await api.get(`/alloc`);
    setAllocations(Array.isArray(data) ? data : []);
  };

  // Reference lists for the report filter dropdowns. Each is fetched
  // independently so that one failing (e.g. /alloc/technicians returning
  // an empty list when the allocated_by migration hasn't run yet, or
  // /departments being unavailable) never blocks the other or the page.
  const fetchFilterMeta = async () => {
    try {
      const { data } = await api.get(`/alloc/technicians`);
      setTechnicians(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Fetch Technicians Error:", error);
      setTechnicians([]);
    }

    try {
      const { data } = await api.get(`/departments`, {
        params: { pageSize: 200 },
      });
      const rows = Array.isArray(data?.data)
        ? data.data
        : Array.isArray(data)
        ? data
        : [];
      setDepartments(rows);
    } catch (error) {
      console.error("Fetch Departments Error:", error);
      setDepartments([]);
    }
  };

  const fetchReport = async () => {
    try {
      setReportLoading(true);
      setReportError("");

      const params = {
        page: currentPage,
        pageSize: rowsPerPage,
      };

      if (filterMonth) params.month = filterMonth;
      if (filterYear) params.year = filterYear;
      if (filterDateFrom) params.date_from = filterDateFrom;
      if (filterDateTo) params.date_to = filterDateTo;
      if (filterProductId) params.product_id = filterProductId;
      if (filterUnitId) params.unit_id = filterUnitId;
      if (filterDepartmentId) params.department_id = filterDepartmentId;
      if (filterAllocatedBy) params.allocated_by = filterAllocatedBy;
      if (statusFilter !== "ALL") params.status = statusFilter;
      if (search.trim()) params.search = search.trim();

      const { data } = await api.get(`/alloc/report`, { params });

      setReportItems(Array.isArray(data?.items) ? data.items : []);
      setReportTotal(Number(data?.total) || 0);
    } catch (error) {
      console.error("Fetch Allocation Report Error:", error);
      setReportError("Failed to load allocation report. Please try again.");
      setReportItems([]);
      setReportTotal(0);
    } finally {
      setReportLoading(false);
    }
  };

  const buildReportParams = () => {
    const params = {};

    if (filterMonth) params.month = filterMonth;
    if (filterYear) params.year = filterYear;
    if (filterDateFrom) params.date_from = filterDateFrom;
    if (filterDateTo) params.date_to = filterDateTo;
    if (filterProductId) params.product_id = filterProductId;
    if (filterUnitId) params.unit_id = filterUnitId;
    if (filterDepartmentId) params.department_id = filterDepartmentId;
    if (filterAllocatedBy) params.allocated_by = filterAllocatedBy;
    if (statusFilter !== "ALL") params.status = statusFilter;
    if (search.trim()) params.search = search.trim();

    return params;
  };

  const exportExcel = async () => {
    try {
      setExporting(true);

      const res = await api.get(`/alloc/report/export`, {
        params: buildReportParams(),
        responseType: "blob",
      });

      const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");

      link.href = blobUrl;
      link.download = "product-allotment.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Export Allocation Report Error:", error);
      alert("Failed to export allocation report");
    } finally {
      setExporting(false);
    }
  };

  // Sourced from the date-aware `pickerProducts`, not `products` -- this is
  // only ever used inside the Create modal's own submit/qty/warning logic.
  const selectedProduct = useMemo(() => {
    return pickerProducts.find((p) => String(p.id) === String(productId));
  }, [pickerProducts, productId]);

  const specLine = (product) => {
    if (!product) return "-";

    const ram = product.ram_gb ? `${product.ram_gb}GB` : "-";
    const storage = product.ssd_gb
      ? `${product.ssd_gb}GB SSD`
      : product.hdd_gb
      ? `${product.hdd_gb}GB HDD`
      : "-";

    return `${product.processor || "-"} / ${ram} / ${storage}`;
  };

  const allocWithProduct = useMemo(() => {
    return allocations.map((row) => ({
      ...row,
      __prod:
        products.find((p) => String(p.id) === String(row.product_id)) || null,
    }));
  }, [allocations, products]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();

    return allocWithProduct.filter((row) => {
      const passStatus =
        statusFilter === "ALL" ? true : row.status === statusFilter;

      if (!q) return passStatus;

      const haystack = [
        row.sku,
        row.product_name,
        row.unit_name,
        row.user_name,
        row.status,
        row.notes,
        row.allocated_at,
        row.return_at,
        row.__prod?.model_no,
        row.__prod?.serial_no,
        row.__prod?.processor,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return passStatus && haystack.includes(q);
    });
  }, [allocWithProduct, search, statusFilter]);

  const stats = useMemo(() => {
    return {
      totalProducts: products.length,
      totalAllocations: allocations.length,
      allocated: allocations.filter((a) => a.status === "ALLOCATED").length,
      returned: allocations.filter((a) => a.status === "RETURNED").length,
      cancelled: allocations.filter((a) => a.status === "CANCELLED").length,
    };
  }, [products, allocations]);

  // Pagination below is now driven by the server (/alloc/report's
  // total/page/pageSize), not by slicing the client-side `filtered` array.
  const totalPages = Math.max(1, Math.ceil(reportTotal / rowsPerPage));
  const indexOfFirst = reportTotal === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
  const indexOfLast = Math.min(currentPage * rowsPerPage, reportTotal);

  const resetCreateForm = () => {
    setUnitId("");
    setUserId("");
    setProductId("");
    setQty(1);
    setNotes("");
    setAllocatedAt(todayInputDate());
  };

  const openCreateModal = () => {
    resetCreateForm();
    setShowCreate(true);
  };

  const submit = async (skipLifeWarning = false) => {
    if (!unitId || !userId || !productId || !qty) {
      alert("Please fill all required fields");
      return;
    }

    if (selectedProduct && Number(qty) > Number(selectedProduct.available_qty)) {
      alert(`Only ${selectedProduct.available_qty} available for ${selectedProduct.sku}`);
      return;
    }

    // Task §6: expected-life-expired is a non-blocking warning only -- never
    // an error. Shown once per submit attempt; "Continue Allocation" re-runs
    // this exact same submit() with skipLifeWarning=true.
    if (!skipLifeWarning && selectedProduct?.life_warning) {
      setLifeWarning(selectedProduct.life_warning);
      return;
    }

    try {
      setSaving(true);

      await api.post(`/alloc`, {
        unit_id: Number(unitId),
        user_id: Number(userId),
        product_id: Number(productId),
        qty: Number(qty),
        notes,
        allocated_at: allocatedAt,
      });

      resetCreateForm();
      setShowCreate(false);
      setLifeWarning(null);

      await fetchProducts();
      await fetchAllocations();
      await fetchReport();

      alert("Product allocated successfully");
    } catch (error) {
      console.error("Allocation Error:", error);
      alert(error?.response?.data?.error || "Failed to allocate product");
    } finally {
      setSaving(false);
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this allocation?")) return;

    try {
      await api.delete(`/alloc/${id}`);
      await fetchProducts();
      await fetchAllocations();
      await fetchReport();
      alert("Allocation deleted successfully");
    } catch (error) {
      console.error("Delete Allocation Error:", error);
      alert("Failed to delete allocation");
    }
  };

  const setStatus = async (row, status) => {
    try {
      await api.put(`/alloc/${row.id}/status`, {
        status,
      });

      await fetchProducts();
      await fetchAllocations();
      await fetchReport();

      alert(`Status changed to ${status}`);
    } catch (error) {
      console.error("Status Update Error:", error);
      alert("Failed to update status");
    }
  };

  const saveEdit = async () => {
    if (!editing) return;

    try {
      setSaving(true);

      await api.put(`/alloc/${editing.id}`, {
        product_id: Number(editing.product_id),
        unit_id: Number(editing.unit_id),
        user_id: Number(editing.user_id),
        qty: Number(editing.qty),
        notes: editing.notes || "",
        allocated_at: editing.allocated_at,
      });

      setEditing(null);

      await fetchProducts();
      await fetchAllocations();
      await fetchReport();

      alert("Allocation updated successfully");
    } catch (error) {
      console.error("Edit Allocation Error:", error);
      alert("Failed to update allocation");
    } finally {
      setSaving(false);
    }
  };

  const hasActiveFilters =
    !!search ||
    statusFilter !== "ALL" ||
    !!filterMonth ||
    !!filterYear ||
    !!filterDateFrom ||
    !!filterDateTo ||
    !!filterProductId ||
    !!filterUnitId ||
    !!filterDepartmentId ||
    !!filterAllocatedBy;

  const clearFilters = () => {
    setSearch("");
    setStatusFilter("ALL");
    setFilterMonth("");
    setFilterYear("");
    setFilterDateFrom("");
    setFilterDateTo("");
    setFilterProductId("");
    setFilterUnitId("");
    setFilterDepartmentId("");
    setFilterAllocatedBy("");
    setCurrentPage(1);
  };

  const getStatusBadge = (status) => {
    if (status === "RETURNED") {
      return (
        <Badge className="unit-status alloc-status-returned">Returned</Badge>
      );
    }

    if (status === "CANCELLED") {
      return (
        <Badge className="unit-status alloc-status-cancelled">Cancelled</Badge>
      );
    }

    return (
      <Badge className="unit-status alloc-status-allocated">Allocated</Badge>
    );
  };

  const exportCSV = () => {
    if (!filtered.length) {
      alert("No data available to export");
      return;
    }

    const headers = [
      "ID",
      "SKU",
      "Product",
      "Unit",
      "User",
      "Qty",
      "Status",
      "Notes",
      "Issue Date",
      "Return Date",
      "Model",
      "Serial",
      "Specification",
    ];

    const rows = filtered.map((row) => [
      row.id,
      row.sku,
      row.product_name,
      row.unit_name,
      row.user_name,
      row.qty,
      row.status,
      row.notes,
      row.allocated_at,
      row.return_at,
      row.__prod?.model_no || "",
      row.__prod?.serial_no || "",
      specLine(row.__prod),
    ]);

    const csvContent = [headers, ...rows]
      .map((row) =>
        row
          .map((value) => `"${String(value || "").replace(/"/g, '""')}"`)
          .join(",")
      )
      .join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = "product-allocations.csv";
    link.click();

    URL.revokeObjectURL(url);
  };

  const org = {
    name: "Jaipuria Schools",
    address: "Sector-XX, City, State - 000000",
    phone: "+91-00000-00000",
    email: "info@jaipuria.edu",
  };

  const esc = (value) =>
    String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");

  const pad2 = (number) => String(number).padStart(2, "0");

  // Purchase date display only (DD MMM YYYY, "-" when unset) -- distinct
  // from `formatDate` above (DD-MM-YYYY, no null guard) which is already
  // used elsewhere on this page for discarded_at and must not change.
  const formatPurchaseDate = (date) => {
    if (!date) return "-";
    const dt = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(dt.getTime())) return "-";
    return dt.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatDate = (date) => {
    const dt = date instanceof Date ? date : new Date(date);
    return `${pad2(dt.getDate())}-${pad2(dt.getMonth() + 1)}-${dt.getFullYear()}`;
  };

  // Reads the Y/M/D calendar triple directly out of a 'YYYY-MM-DD...'
  // string rather than round-tripping through `new Date()` -- the backend
  // (services/productLifecycleService.js's parseDateOnly) always sends
  // allocated_at as a plain date-only string, and parsing that via `Date`
  // then reading local getters can shift the date by a day in timezones
  // west of UTC. Falls back to Date parsing only for non-ISO inputs.
  const toDateInputValue = (value) => {
    if (!value) return "";
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
    if (match) return `${match[1]}-${match[2]}-${match[3]}`;

    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
  };

  const todayInputDate = () => {
    const d = new Date();
    return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
  };

  const buildSignSheetHTML = (rows, title = "Product Allocation Sign Sheet") => {
    const today = formatDate(new Date());

    const itemRows = rows
      .map((row, index) => {
        const product =
          products.find((p) => String(p.id) === String(row.product_id)) || {};

        return `
          <tr>
            <td>${index + 1}</td>
            <td>
              <div><b>${esc(row.sku || "-")}</b> — ${esc(row.product_name || "-")}</div>
              <div style="color:#6b7280;font-size:11px">
                M: ${esc(product.model_no || "-")} • S: ${esc(product.serial_no || "-")} • ${esc(specLine(product))}
              </div>
            </td>
            <td>${esc(row.unit_name || "-")}</td>
            <td>${esc(row.user_name || "-")}</td>
            <td style="text-align:right;font-weight:700">${Number(row?.qty ?? 0)}</td>
            <td>${esc(row.status || "-")}</td>
            <td>${esc(row.notes || "-")}</td>
          </tr>`;
      })
      .join("");

    const singleMeta =
      rows.length === 1
        ? (() => {
            const row = rows[0];
            const product =
              products.find((p) => String(p.id) === String(row.product_id)) || {};

            return `
              <table class="meta">
                <tr>
                  <td><b>Unit:</b> ${esc(row.unit_name || "-")}</td>
                  <td><b>User:</b> ${esc(row.user_name || "-")}</td>
                  <td><b>Model/Serial:</b> ${esc(product.model_no || "-")} / ${esc(product.serial_no || "-")}</td>
                </tr>
              </table>`;
          })()
        : "";

    return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8"/>
<title>${esc(title)}</title>
<style>
  @page { size: A4; margin: 16mm 14mm; }
  html, body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  body { font-family: Arial, sans-serif; color: #111827; }
  .head { display:flex; justify-content:space-between; align-items:flex-start; border-bottom:2px solid #e5e7eb; padding-bottom:10px; margin-bottom:10px; }
  .brand { font-weight:800; font-size:20px; line-height:1.1; }
  .muted { color:#6b7280; font-size:12px; }
  .title { text-align:center; margin:8px 0 12px; font-size:18px; font-weight:800; }
  .meta { width:100%; border:1px solid #e5e7eb; border-radius:8px; padding:8px; font-size:12px; margin-bottom:10px; }
  .meta td { padding:4px 6px; vertical-align:top; }
  .table { width:100%; border-collapse:collapse; margin-top:8px; font-size:12px; }
  .table th, .table td { border:1px solid #e5e7eb; padding:6px 8px; }
  .table thead th { background:#f9fafb; text-transform:uppercase; letter-spacing:.02em; font-size:11px; color:#6b7280; }
  .sign-grid { display:grid; grid-template-columns:1fr 1fr 1fr; gap:14px; margin-top:18px; }
  .sign-card { border:1px dashed #cbd5e1; border-radius:8px; padding:10px; }
  .sign-line { border-top:1px solid #94a3b8; margin-top:28px; }
  .label { font-size:11px; color:#6b7280; }
  .foot { margin-top:14px; font-size:11px; color:#6b7280; }
  .stamp { border:1px dashed #94a3b8; height:70px; display:flex; align-items:center; justify-content:center; color:#64748b; border-radius:6px; margin-top:6px;}
</style>
</head>
<body>
  <div class="head">
    <div>
      <div class="brand">${esc(org.name)}</div>
      <div class="muted">${esc(org.address)}</div>
      <div class="muted">${esc(org.phone)} | ${esc(org.email)}</div>
    </div>
    <div class="muted" style="text-align:right">
      <div>Date: <b>${esc(today)}</b></div>
      <div>Doc #: ____________</div>
    </div>
  </div>

  <div class="title">${esc(title)}</div>

  <table class="meta">
    <tr>
      <td><b>Total Items:</b> ${rows.length}</td>
      <td><b>Prepared By:</b> ____________________</td>
      <td><b>Checked By:</b> ____________________</td>
    </tr>
  </table>

  ${singleMeta}

  <table class="table">
    <thead>
      <tr>
        <th>#</th>
        <th>Product & Spec</th>
        <th>Unit</th>
        <th>User</th>
        <th>Qty</th>
        <th>Status</th>
        <th>Notes</th>
      </tr>
    </thead>
    <tbody>${itemRows}</tbody>
  </table>

  <div class="sign-grid">
    <div class="sign-card">
      <div><b>Issued By</b></div>
      <div class="label">Name & Signature</div>
      <div class="sign-line"></div>
      <div class="label">Date</div>
      <div>____ / ____ / ______</div>
      <div class="stamp">Office Stamp</div>
    </div>
    <div class="sign-card">
      <div><b>Received By</b></div>
      <div class="label">Name & Signature</div>
      <div class="sign-line"></div>
      <div class="label">Date</div>
      <div>____ / ____ / ______</div>
    </div>
    <div class="sign-card">
      <div><b>Verified By</b></div>
      <div class="label">Name & Signature</div>
      <div class="sign-line"></div>
      <div class="label">Date</div>
      <div>____ / ____ / ______</div>
    </div>
  </div>

  <div class="foot">
    <b>Note:</b> Items received in good condition unless otherwise stated. Discrepancies must be reported within 24 hours.
  </div>

  <script>
    window.onload = function(){ try{ window.focus(); }catch(e){} window.print(); };
  </script>
</body>
</html>`;
  };

  const printRows = (rows, title) => {
    const html = buildSignSheetHTML(rows || [], title);
    const printWindow = window.open("", "_blank", "width=900,height=1000");

    if (!printWindow) {
      alert("Popup blocked. Please allow popups to print.");
      return;
    }

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();

    printWindow.onload = () => {
      try {
        printWindow.focus();
      } catch {}
      printWindow.print();
    };
  };

  const printSingle = (row) => {
    if (row) printRows([row], "Product Allocation Sign Sheet - Single");
  };

  const printAll = () => {
    printRows(filtered || [], "Product Allocation Sign Sheet - Filtered");
  };

  return (
    <div className="unit-page inventory-allocation-theme">
      <div className="allocation-heading-box">
        <div className="allocation-heading-content">
          <div className="allocation-heading-icon">
            <i className="fa-solid fa-arrow-right-arrow-left" aria-hidden="true"></i>
          </div>

          <div>
            <div className="unit-page-label">Inventory</div>
            <h2>Product Allocation</h2>
            <p>Allocate products to users, manage returns, cancellations and print sign sheets.</p>
          </div>
        </div>

        <div className="unit-header-actions">
          <Button
            className="unit-btn unit-btn-light"
            onClick={() => {
              fetchAll();
              fetchReport();
            }}
            disabled={loading}
          >
            {loading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            )}
            Refresh
          </Button>

          <div className="allocation-utility-actions" role="group" aria-label="Export and print actions">
            <Button className="unit-btn allocation-btn-utility" onClick={exportCSV}>
              <i className="fa-solid fa-file-csv" aria-hidden="true"></i>
              Export CSV
            </Button>

            {canExport && (
              <Button
                className="unit-btn allocation-btn-utility"
                onClick={exportExcel}
                disabled={exporting}
              >
                {exporting ? (
                  <>
                    <Spinner animation="border" size="sm" />
                    Exporting...
                  </>
                ) : (
                  <>
                    <i className="fa-solid fa-file-excel" aria-hidden="true"></i>
                    Export Excel
                  </>
                )}
              </Button>
            )}

            <Button className="unit-btn allocation-btn-utility" onClick={printAll}>
              <i className="fa-solid fa-print" aria-hidden="true"></i>
              Print {hasActiveFilters ? "Filtered" : "All"}
            </Button>
          </div>

          {canCreate && (
            <Button className="unit-btn unit-btn-primary" onClick={openCreateModal}>
              <i className="fa-solid fa-plus" aria-hidden="true"></i>
              Allocate
            </Button>
          )}
        </div>
      </div>

      <div className="unit-stats-row">
        <div className="unit-stat-card allocation-stat-blue">
          <div className="allocation-stat-content">
            <div className="allocation-stat-copy">
              <span>Total Products</span>
              <strong>{stats.totalProducts}</strong>
            </div>
            <div className="allocation-stat-icon">
              <i className="fa-solid fa-boxes-stacked" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card allocation-stat-purple">
          <div className="allocation-stat-content">
            <div className="allocation-stat-copy">
              <span>Total Records</span>
              <strong>{stats.totalAllocations}</strong>
            </div>
            <div className="allocation-stat-icon">
              <i className="fa-solid fa-list-check" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card allocation-stat-orange">
          <div className="allocation-stat-content">
            <div className="allocation-stat-copy">
              <span>Allocated</span>
              <strong>{stats.allocated}</strong>
            </div>
            <div className="allocation-stat-icon">
              <i className="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card allocation-stat-green">
          <div className="allocation-stat-content">
            <div className="allocation-stat-copy">
              <span>Returned</span>
              <strong>{stats.returned}</strong>
            </div>
            <div className="allocation-stat-icon">
              <i className="fa-solid fa-rotate-left" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card allocation-stat-red">
          <div className="allocation-stat-content">
            <div className="allocation-stat-copy">
              <span>Cancelled</span>
              <strong>{stats.cancelled}</strong>
            </div>
            <div className="allocation-stat-icon">
              <i className="fa-solid fa-ban" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="unit-card">
        <div className="unit-toolbar">
          <div className="allocation-section-title">
            <div className="allocation-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

            <div>
              <h5>Allocation List</h5>
              <p>Search, filter, update status, edit quantity and print allocation records.</p>
            </div>
          </div>

          <div className="unit-toolbar-actions">
            <InputGroup className="unit-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>

              <Form.Control
                placeholder="Search product, model, serial, unit, user..."
                aria-label="Search product, model, serial, unit, user"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />

              {search && (
                <Button
                  className="unit-clear-btn"
                  onClick={() => setSearch("")}
                  title="Clear search"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}
            </InputGroup>

            <Form.Select
              className="unit-page-size"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="ALL">All Status</option>
              <option value="ALLOCATED">Allocated</option>
              <option value="RETURNED">Returned</option>
              <option value="CANCELLED">Cancelled</option>
            </Form.Select>

            <Form.Select
              className="unit-page-size"
              value={rowsPerPage}
              onChange={(e) => setRowsPerPage(Number(e.target.value))}
            >
              <option value={5}>5 rows</option>
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
            </Form.Select>

          </div>
        </div>

        <div className="allocation-advanced-filters">
          <div className="allocation-filter-field">
            <Form.Label className="allocation-filter-label">Month</Form.Label>
            <Form.Select
              className="allocation-filter-control"
              value={filterMonth}
              onChange={(e) => setFilterMonth(e.target.value)}
            >
              <option value="">All Months</option>
              {[
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ].map((label, index) => (
                <option key={label} value={index + 1}>
                  {label}
                </option>
              ))}
            </Form.Select>
          </div>

          <div className="allocation-filter-field">
            <Form.Label className="allocation-filter-label">Year</Form.Label>
            <Form.Control
              type="number"
              className="allocation-filter-control"
              placeholder="e.g. 2026"
              value={filterYear}
              onChange={(e) => setFilterYear(e.target.value)}
            />
          </div>

          <div className="allocation-filter-field">
            <Form.Label className="allocation-filter-label">Date From</Form.Label>
            <Form.Control
              type="date"
              className="allocation-filter-control"
              value={filterDateFrom}
              onChange={(e) => setFilterDateFrom(e.target.value)}
            />
          </div>

          <div className="allocation-filter-field">
            <Form.Label className="allocation-filter-label">Date To</Form.Label>
            <Form.Control
              type="date"
              className="allocation-filter-control"
              value={filterDateTo}
              onChange={(e) => setFilterDateTo(e.target.value)}
            />
          </div>

          <div className="allocation-filter-field">
            <Form.Label className="allocation-filter-label">Unit</Form.Label>
            <Form.Select
              className="allocation-filter-control"
              value={filterUnitId}
              onChange={(e) => setFilterUnitId(e.target.value)}
            >
              <option value="">All Units</option>
              {units.map((unit) => (
                <option key={unit.id} value={unit.id}>
                  {unit.name}
                </option>
              ))}
            </Form.Select>
          </div>

          <div className="allocation-filter-field">
            <Form.Label className="allocation-filter-label">Product</Form.Label>
            <Form.Select
              className="allocation-filter-control"
              value={filterProductId}
              onChange={(e) => setFilterProductId(e.target.value)}
            >
              <option value="">All Products</option>
              {products.map((product) => (
                <option key={product.id} value={product.id}>
                  {product.sku} — {product.name}
                </option>
              ))}
            </Form.Select>
          </div>

          <div className="allocation-filter-field">
            <Form.Label className="allocation-filter-label">Department</Form.Label>
            <Form.Select
              className="allocation-filter-control"
              value={filterDepartmentId}
              onChange={(e) => setFilterDepartmentId(e.target.value)}
            >
              <option value="">All Departments</option>
              {departments.map((dept) => (
                <option key={dept.id} value={dept.id}>
                  {dept.name}
                </option>
              ))}
            </Form.Select>
          </div>

          <div className="allocation-filter-field">
            <Form.Label className="allocation-filter-label">Technician</Form.Label>
            <Form.Select
              className="allocation-filter-control"
              value={filterAllocatedBy}
              onChange={(e) => setFilterAllocatedBy(e.target.value)}
            >
              <option value="">All Technicians</option>
              {technicians.map((tech) => (
                <option key={tech.id} value={tech.id}>
                  {tech.name}
                </option>
              ))}
            </Form.Select>
          </div>

          {hasActiveFilters && (
            <div className="allocation-filter-field allocation-filter-field-reset">
              <Button
                className="unit-btn unit-btn-light w-100"
                onClick={clearFilters}
              >
                <i className="fa-solid fa-rotate-left" aria-hidden="true"></i>
                Reset Filters
              </Button>
            </div>
          )}
        </div>

        <div className="unit-table-wrapper">
          {reportError ? (
            <div className="unit-empty">
              <div className="unit-empty-icon">
                <i className="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
              </div>
              <h5>Something went wrong</h5>
              <p>{reportError}</p>
              <Button className="unit-btn unit-btn-primary" onClick={fetchReport}>
                <i className="fa-solid fa-rotate" aria-hidden="true"></i>
                Retry
              </Button>
            </div>
          ) : reportLoading ? (
            <div className="unit-loader">
              <Spinner animation="border" />
              <p>Loading allocations...</p>
            </div>
          ) : (
            <table className="table unit-table">
              <thead>
                <tr>
                  <th style={{ width: "70px" }}>ID</th>
                  <th>Product</th>
                  <th>Unit</th>
                  <th>Allotted To</th>
                  <th>Department</th>
                  <th>Designation</th>
                  <th>Allotted By</th>
                  <th>Qty</th>
                  <th>Status</th>
                  <th>Allotment Date</th>
                  <th>Return Date</th>
                  <th>Remarks</th>
                  <th>Created At</th>
                  <th className="text-end" style={{ width: "250px" }}>
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody>
                {reportItems.length > 0 ? (
                  reportItems.map((row) => {
                    return (
                      <tr key={row.id}>
                        <td>
                          <span className="unit-id">#{row.id}</span>
                        </td>

                        <td>
                          <div className="unit-name-box">
                            <div className="unit-letter">
                              {row.product_name?.charAt(0)?.toUpperCase() || "P"}
                            </div>

                            <div>
                              <strong>
                                {row.product_code ? `${row.product_code} — ` : ""}
                                {row.product_name || "-"}
                              </strong>
                              <small>
                                S: {row.serial_no || "-"} • {row.brand || "-"}
                              </small>
                            </div>
                          </div>
                        </td>

                        <td>
                          <Badge className="unit-status allocation-unit-badge">
                            <i className="fa-solid fa-building me-1" aria-hidden="true"></i>
                            {row.unit_name || "-"}
                          </Badge>
                        </td>

                        <td>
                          <Badge className="unit-status allocation-user-badge">
                            <i className="fa-regular fa-user me-1" aria-hidden="true"></i>
                            {row.allotted_to || "-"}
                          </Badge>
                        </td>

                        <td>{row.department_name || "—"}</td>
                        <td>{row.designation_name || "—"}</td>
                        <td>{row.allotted_by || "—"}</td>

                        <td>
                          <span className="unit-id">{row.qty}</span>
                        </td>

                        <td>{getStatusBadge(row.status)}</td>

                        <td>{row.allocated_at ? formatDate(row.allocated_at) : "-"}</td>
                        <td>{row.return_at ? formatDate(row.return_at) : "-"}</td>

                        <td
                          style={{
                            maxWidth: "180px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={row.remarks || ""}
                        >
                          {row.remarks || "-"}
                        </td>

                        <td>{row.created_at ? formatDate(row.created_at) : "-"}</td>

                        <td>
                          <div className="unit-actions">
                            {canEdit && (
                              <Button
                                className="unit-icon-btn unit-edit"
                                title="Edit"
                                aria-label={`Edit allocation for ${row.product_name || "product"}`}
                                onClick={() =>
                                  setEditing({
                                    ...row,
                                    notes: row.remarks || "",
                                    allocated_at: toDateInputValue(row.allocated_at),
                                  })
                                }
                              >
                                <i className="fa-solid fa-pen" aria-hidden="true"></i>
                              </Button>
                            )}

                            {canDelete && (
                              <Button
                                className="unit-icon-btn unit-delete"
                                title="Delete"
                                aria-label={`Delete allocation for ${row.product_name || "product"}`}
                                onClick={() => remove(row.id)}
                              >
                                <i className="fa-solid fa-trash" aria-hidden="true"></i>
                              </Button>
                            )}

                            {canChangeStatus && (
                              <>
                                <Button
                                  className="unit-icon-btn unit-edit"
                                  title="Mark Returned"
                                  aria-label={`Mark ${row.product_name || "allocation"} as returned`}
                                  onClick={() => setStatus(row, "RETURNED")}
                                >
                                  <i className="fa-solid fa-rotate-left" aria-hidden="true"></i>
                                </Button>

                                <Button
                                  className="unit-icon-btn unit-delete"
                                  title="Cancel Allocation"
                                  aria-label={`Cancel allocation for ${row.product_name || "product"}`}
                                  onClick={() => setStatus(row, "CANCELLED")}
                                >
                                  <i className="fa-solid fa-ban" aria-hidden="true"></i>
                                </Button>
                              </>
                            )}

                            <Button
                              className="unit-icon-btn unit-edit"
                              title="Print Sign Sheet"
                              aria-label={`Print sign sheet for ${row.product_name || "product"}`}
                              onClick={() =>
                                printSingle({
                                  ...row,
                                  sku: row.product_code,
                                  user_name: row.allotted_to,
                                  notes: row.remarks,
                                })
                              }
                            >
                              <i className="fa-solid fa-print" aria-hidden="true"></i>
                            </Button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="14">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-box-open" aria-hidden="true"></i>
                        </div>
                        <h5>No allocations found</h5>
                        <p>Try another filter or allocate a new product.</p>

                        {canCreate && (
                          <Button
                            className="unit-btn unit-btn-primary"
                            onClick={openCreateModal}
                          >
                            <i className="fa-solid fa-plus" aria-hidden="true"></i>
                            Allocate Product
                          </Button>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">
            Showing <strong>{indexOfFirst}</strong> to{" "}
            <strong>{indexOfLast}</strong> of <strong>{reportTotal}</strong>{" "}
            entries
          </div>

          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => prev - 1)}
              />

              {compactPageItems([...Array(totalPages)].map((_, index) => (
                <Pagination.Item
                  key={index + 1}
                  active={index + 1 === currentPage}
                  onClick={() => setCurrentPage(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
              )), currentPage)}

              <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((prev) => prev + 1)}
              />
            </Pagination>
          )}
        </div>
      </div>

      <Modal
        show={showCreate}
        onHide={() => setShowCreate(false)}
        centered
        className="unit-modal"
        dialogClassName="admin-teal-modal"
        backdropClassName="admin-teal-backdrop"
      >
        <Modal.Header closeButton>
          <div className="allocation-modal-heading">
            <div className="allocation-modal-icon">
              <i className="fa-solid fa-share-from-square" aria-hidden="true"></i>
            </div>
            <div>
              <small>Inventory Action</small>
              <Modal.Title>Allocate Product</Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="row g-3">
            <div className="col-md-6">
              <Form.Group>
                <Form.Label>Unit</Form.Label>
                <Form.Select
                  value={unitId}
                  onChange={(e) => setUnitId(e.target.value)}
                >
                  <option value="">Select Unit</option>
                  {units.map((unit) => (
                    <option key={unit.id} value={unit.id}>
                      {unit.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group>
                <Form.Label>User</Form.Label>
                <Form.Select
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                  disabled={!unitId}
                >
                  <option value="">Select User</option>
                  {users.map((u) => (
                    <option key={u.id} value={u.id}>
                      {u.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-md-8">
              <Form.Group>
                <Form.Label>
                  Product{" "}
                  {pickerLoading && <Spinner animation="border" size="sm" className="ms-1" />}
                </Form.Label>
                <Form.Select
                  value={productId}
                  onChange={(e) => setProductId(e.target.value)}
                  disabled={pickerLoading}
                >
                  <option value="">Select Product</option>
                  {pickerProducts.map((product) => (
                    <option key={product.id} value={product.id}>
                      {product.sku} — {product.name} | Purchase:{" "}
                      {formatPurchaseDate(product.purchase_date)}
                      {product.historical_only
                        ? ` (Discarded ${formatDate(product.discarded_at)} — historical allocation only)`
                        : ` (Avail: ${product.available_qty})`}
                    </option>
                  ))}
                </Form.Select>

                {selectedProduct && selectedProduct.historical_only && (
                  <div className="unit-selected-box mt-2" style={{ borderColor: "#dc3545" }}>
                    <strong>{selectedProduct.name}</strong>
                    <div className="text-danger small">
                      Discarded {formatDate(selectedProduct.discarded_at)}
                    </div>
                    <div className="small">Historical allocation allowed for the selected date only.</div>
                  </div>
                )}

                {selectedProduct && !selectedProduct.historical_only && (
                  <small className="text-muted d-block mt-2">
                    Total: {selectedProduct.total_qty} • Available:{" "}
                    {selectedProduct.available_qty} <br />
                    M: {selectedProduct.model_no || "-"} • S:{" "}
                    {selectedProduct.serial_no || "-"} • {specLine(selectedProduct)} <br />
                    Purchase: {formatPurchaseDate(selectedProduct.purchase_date)}
                  </small>
                )}
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group>
                <Form.Label>Qty</Form.Label>
                <Form.Control
                  type="number"
                  min="1"
                  value={qty}
                  onChange={(e) => setQty(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group>
                <Form.Label>
                  Allocation Date <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  max={todayInputDate()}
                  value={allocatedAt}
                  onChange={(e) => setAllocatedAt(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className="col-12">
              <Form.Group>
                <Form.Label>Notes</Form.Label>
                <Form.Control
                  placeholder="Any remarks..."
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
              </Form.Group>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="unit-btn unit-btn-light"
            onClick={() => setShowCreate(false)}
          >
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button
            className="unit-btn unit-btn-primary"
            onClick={() => submit()}
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" />
                Allocating...
              </>
            ) : (
              <>
                <i className="fa-solid fa-share-from-square" aria-hidden="true"></i>
                Allocate
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={!!editing}
        onHide={() => setEditing(null)}
        centered
        className="unit-modal"
        dialogClassName="admin-teal-modal"
        backdropClassName="admin-teal-backdrop"
      >
        <Modal.Header closeButton>
          <div className="allocation-modal-heading">
            <div className="allocation-modal-icon allocation-modal-icon-edit">
              <i className="fa-solid fa-pen-to-square" aria-hidden="true"></i>
            </div>
            <div>
              <small>Inventory Action</small>
              <Modal.Title>Edit Allocation</Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Qty</Form.Label>
            <Form.Control
              type="number"
              min="1"
              value={editing?.qty || ""}
              onChange={(e) =>
                setEditing({
                  ...editing,
                  qty: e.target.value,
                })
              }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              Allocation Date <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="date"
              max={todayInputDate()}
              value={editing?.allocated_at || ""}
              onChange={(e) =>
                setEditing({
                  ...editing,
                  allocated_at: e.target.value,
                })
              }
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Notes</Form.Label>
            <Form.Control
              value={editing?.notes || ""}
              onChange={(e) =>
                setEditing({
                  ...editing,
                  notes: e.target.value,
                })
              }
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={() => setEditing(null)}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button
            className="unit-btn unit-btn-primary"
            onClick={saveEdit}
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                Save
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={!!lifeWarning}
        onHide={() => setLifeWarning(null)}
        centered
        className="unit-modal"
        dialogClassName="admin-teal-modal"
        backdropClassName="admin-teal-backdrop"
      >
        <Modal.Header closeButton>
          <Modal.Title>Expected Life Exceeded</Modal.Title>
        </Modal.Header>

        <Modal.Body>{lifeWarning}</Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={() => setLifeWarning(null)}>
            Cancel
          </Button>
          <Button
            className="unit-btn unit-btn-primary"
            onClick={() => submit(true)}
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" />
                Allocating...
              </>
            ) : (
              "Continue Allocation"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}